/** 中文 */
export default {
    age: "年龄",
    submit: "提交",
    netWorkError: "网络链接异常请重新链接",
    example: {
        name: "张三"
    }
}